import { Field } from "enums";
import Validation from "services/validation.service";
import lang from "translations";

const initialFormState = (initialState = {}) => {
  const {
    displayName = "",
    merchantUrl = "",
    merchantId = "",
    merchantSecret = "",
    isDefault,
    venueId,
    minimumTopUp,
    maximumTopUp,
    mdr,
  } = initialState;
  return {
    displayName: {
      name: "displayName",
      value: displayName,
      type: Field.INPUT,
      validations: [Validation.required()],
      required: true,
      maxLength: 75,
    },
    merchantUrl: {
      name: "merchantUrl",
      value: merchantUrl,
      type: Field.INPUT,
      validations: [Validation.required(), Validation.url()],
      required: true,
    },
    merchantId: {
      name: "merchantId",
      value: merchantId,
      type: Field.INPUT,
      validations: [Validation.required()],
      required: true,
    },
    merchantSecret: {
      name: "merchantSecret",
      value: merchantSecret,
      type: Field.INPUT,
      validations: [Validation.required()],
      required: true,
    },
    isDefault: {
      name: "isDefault",
      value: isDefault,
      type: Field.CHECKBOX,
      title: lang.isDefaultPaymentGateway,
    },
    venueId: {
      name: "venueId",
      value: venueId,
      type: Field.INPUT,
      required: true,
    },
    minimumTopUp: {
      name: "minimumTopUp",
      value: minimumTopUp,
      type: Field.NUMBER,
    },
    maximumTopUp: {
      name: "maximumTopUp",
      value: maximumTopUp,
      type: Field.NUMBER,
    },
    mdr: {
      name: "mdr",
      value: mdr,
      type: Field.NUMBER,
    },
  };
};

export default initialFormState;
